import React from 'react';
import * as saveAction from './../../action/save';
import { InitialSave, Help, SaveInvoked, ReSave, ReSaved } from './saveContent';
import { connect } from 'react-redux'
import { withCookies } from 'react-cookie';

class Save extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            showHelpContent: false
        }
    }

    onHelpCheck = (isBackInvoked = false) => {    
        if(isBackInvoked) saveAction.backInvoked(isBackInvoked, this.props.dispatch)    
        saveAction.helpSaveOverlay(this.props.helpSave, this.props.dispatch);
    }
    showHelpContent = () => {
        this.setState({
            showHelpContent: !this.state.showHelpContent
        })
    }

    componentWillMount = () => {
        saveAction.expiryDate(saveAction.saveDate(), this.props.dispatch)
    }

    handleKeyDown(e) {
        if (e.keyCode === 13 || e.keyCode === 32) {
            this.onAcordionClick(e);
        }
    }

    handleKeyDownSibling(e) {
        let prevSibling = e.target.previousElementSibling;
        if (e.keyCode === 13 || e.keyCode === 32) {
            prevSibling.click();
        }
    }

    onAcordionClick(e) {
        let accordHeaderElement = (e.target.className.indexOf('m_accordion-summary') !== -1) && e.target;
        if (!accordHeaderElement) {
            accordHeaderElement = (e.target.parentElement.className.indexOf('m_accordion-summary') !== -1) && e.target.parentElement;
        }
        if (accordHeaderElement) {
            let nextElementSibling = e.target.nextElementSibling;
            if (accordHeaderElement.className.indexOf("open") < 0) {
                if (this.currOpenHelpAccordion && this.currOpenHelpAccordion.className.indexOf('open') !== -1) {
                    this.currOpenHelpAccordion.className = this.currOpenHelpAccordion.className.replace(" open", "");
                    this.currOpenHelpAccordion.setAttribute('aria-expanded', false);
                    let currentNextElementSibling = this.currOpenHelpAccordion.nextElementSibling;
                    if (currentNextElementSibling) {
                        currentNextElementSibling.setAttribute('tabIndex', '-1');
                    }
                }
                accordHeaderElement.className = accordHeaderElement.className.concat(" open");
                this.currOpenHelpAccordion = accordHeaderElement;
                accordHeaderElement.setAttribute('aria-expanded', true);
                if (nextElementSibling) {
                    nextElementSibling.setAttribute('tabIndex', '0');
                }
            }
            else {
                accordHeaderElement.className = accordHeaderElement.className.replace(" open", "");
                this.currOpenHelpAccordion = undefined;
                accordHeaderElement.setAttribute('aria-expanded', false);
                if (nextElementSibling) {
                    nextElementSibling.setAttribute('tabIndex', '-1');
                }
            }
        }
    }

    render() {
        let initalSave = '';
        let helpSection = '';
        let saveDone = '';
        let reSave = '';
        let reSaved = '';
        let isHelp = this.props.helpSave;
        let isSaveInvoked = this.props.save_Invoked;
        let isCreditDone = this.props.creditDone;
        let isBackInvoked = this.props.backInvoked;
        let emailID = this.props.emailID;

        if (isHelp) {
            helpSection = <Help onHelpCheck={this.onHelpCheck} onAcordionClick={(e) => this.onAcordionClick(e)} handleKeyDown={(e) => this.handleKeyDown(e)} handleKeyDownSibling={(e) => this.handleKeyDownSibling(e)} />
        } else {
            if (!this.props.isResumedEmailMtn) {
                if (isSaveInvoked || isCreditDone) {
                    saveDone = <SaveInvoked onHelpCheck={this.onHelpCheck} cart={this.props.cart} buildProductState={this.props.buildProductState} lqState={this.props.lqState} monno={this.props.monno} emailID={emailID} closeModel={this.props.closeModel} saveDate={this.props.saveDate} shopDeals={this.props.shopDeals} savedCartClick={this.props.savedCartClick} isFlashOfferApplied={this.props.isFlashOfferApplied} />
                } else {
                    initalSave = <React.Fragment><InitialSave cart={this.props.cart} buildProductState={this.props.buildProductState} lqState={this.props.lqState} isBackInvoked={isBackInvoked} helpContent = {this.state.showHelpContent} showHelpContent={this.showHelpContent} onHelpCheck={this.onHelpCheck} validateInput={this.props.validateInput} emailID={this.props.emailID} saveClick={this.props.saveClick} closeModel={this.props.closeModel}
                        validateIpt={this.props.validateIpt} emailError={this.props.emailError} onAcordionClick={(e) => this.onAcordionClick(e)} handleKeyDown={(e) => this.handleKeyDown(e)} handleKeyDownSibling={(e) => this.handleKeyDownSibling(e)}  mtnError={this.props.mtnError} />
                    </React.Fragment>;
                }
            } else {
                if (!isSaveInvoked) {
                    reSave = <ReSave onHelpCheck={this.onHelpCheck} buildProductState={this.props.buildProductState} lqState={this.props.lqState} saveClick={this.props.saveClick} closeModel={this.props.closeModel} monno={this.props.monno} saveDate={this.props.saveDate} isFlashOfferApplied={this.props.isFlashOfferApplied} />;
                } else {
                    reSaved = <ReSaved monno={this.props.monno} buildProductState={this.props.buildProductState} lqState={this.props.lqState} saveDate={this.props.saveDate} cart={this.props.cart}  closeModel={this.props.closeModel} isFlashOfferApplied={this.props.isFlashOfferApplied} />;
                }
            }
        }

        return (
            <div>
                {initalSave}
                {helpSection}
                {saveDone}
                {reSave}
                {reSaved}
            </div>
        )
    }

}

const mapStateToProps = (state) => {
    return {
        lqState: state.loopQual,
        buildProductState: state.buildProduct,
        cart: state.cart
    }
}

export default withCookies(connect(
    mapStateToProps,
)(Save));